<template>
  <el-dialog
    title="通道费告知函确认记录"
    :visible.sync="visible"
    width="60%"
    center
    @close="onClose">
    <div class="record_content">
      <div class="record_row">
        <div class="title">告知函内容：</div>
        <el-table :data="noticeContents" border>
          <el-table-column label="调整后通道费" align="center">
            <template slot-scope="{ row }">{{ formatNewSlotting(row) }}</template>
          </el-table-column>
          <el-table-column prop="confirmTime" label="执行时间" align="center"></el-table-column>
        </el-table>
      </div>
      <div class="record_row">
        <div class="title">操作日志：</div>
        <el-table :data="logList" border>
          <el-table-column prop="companyName" label="商户名称" align="center"></el-table-column>
          <el-table-column prop="operationDimension" label="操作维度" align="center"></el-table-column>
          <el-table-column prop="operatorName" label="操作账号" align="center"></el-table-column>
          <el-table-column prop="operationTime" label="操作时间" align="center"></el-table-column>
          <el-table-column prop="operationIp" label="操作设备IP" align="center"></el-table-column>
          <el-table-column prop="operationContent" label="操作内容" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ChannelFeeRecord',
  data () {
    return {
      visible: false,
      noticeContents: [], // 告知函内容：oldSlottingRate/newSlottingRate/status/confirmTime
      logList: [] // 操作日志：companyName/operationDimension/operatorName/operationTime/operationIp/operationContent
    }
  },
  methods: {
    // result 由调用方（goDetail）预取传入
    open (result) {
      this.visible = true
      this.setData(result)
    },
    setData (result) {
      // 告知函内容列表过滤掉待确认（WAIT_CONFIRM）的数据，只展示已生效/已确认记录
      const contents = (result && result.noticeContents) || []
      this.noticeContents = contents.filter(item => item.status !== 'WAIT_CONFIRM')
      this.logList = (result && result.operationLogs) || []
    },
    // 调整后通道费：基准名称 + 费率（百分比，保留两位小数）
    formatNewSlotting (row) {
      const name = (row && row.newSlottingBasisName) || ''
      const rate = row && row.newSlottingRate
      if (rate === null || rate === undefined || rate === '' || isNaN(Number(rate))) return name || '--'
      return `${name}*${(Number(rate) * 100).toFixed(2)}%`
    },
    onClose () {
      this.visible = false
      this.noticeContents = []
      this.logList = []
    }
  }
}
</script>
<style lang="less" scoped>
.record_content {
  max-height: 500px;
  overflow-y: auto;
  .record_row {
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    .title {
      font-weight: bold;
      margin-bottom: 12px;
    }
  }
}
</style>
